<template>
  <div class="signdetails">
    <div v-if="nullData">此方案已撤回</div>
    <div v-else>
      <div v-html="tag" class="tag-list"></div>
      <div v-if="signData.SignState!==2 && signData.isSign" class="s-btn van-hairline--top">
        <div @click="goSigning">签字</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "signdetails",
  data() {
    return {
      previewList: [],
      signData: {},
      tag: "",
      nullData: false
    };
  },
  created() {
    if (this.$route.query.fromMessage) {
      // 从消息页面跳转而来
      this.signData = JSON.parse(
        JSON.parse(this.$store.state.messageInfo).DetailParameter
      );
      this.getRouterIsMsg();
    } else {
      // 从签名列表跳转而来
      this.signData = this.$store.state.parentInfo.signData;
      if (this.signData.SignState === 2) {
        this.viewSign(this.signData.SignFileDetailID);
      } else {
        this.getSign(this.signData.SignFileID); //未签字
      }
    }
  },
  methods: {
    async getRouterIsMsg() {
      //消息进来后走此方法
      this.xy.loading();
      let res = await this.xyapi.get(
        `${this.$store.state.apiPath}/api/SignFileManage/GetSignFileByID`,
        {
          SignFileID: this.signData.SignFileID
        }
      );
      if (res.success) {
        if (res.data.State === 2) {
          this.getSignStateByID();
        }
        if (res.data.State === 3) {
          this.xy.msgError("此方案已撤回");
        }
      }
      this.xy.unloading();
    },
    async getSignStateByID() {
      this.xy.loading();
      let res = await this.xyapi.get(
        `${this.$store.state.apiPath}/api/SignFileDetailManage/GetSignStateByID`,
        {
          SignFileID: this.signData.SignFileID,
          StudentID: this.signData.StudentID
        }
      );
      if (res.success) {
        let formats = "YYYY-MM-DD HH:mm:ss";
        let endTime = this.xy.moment(res.data.EndTime, formats);
        let nowDate = this.xy.moment().format(formats);
        let isSigning = endTime.isAfter(nowDate);
        this.signData["isSign"] = isSigning ? true : false;
        if (res.data.SignState === 2) {
          this.viewSign(res.data.SignFileDetailID); //已签字
        } else {
          this.getSign(this.signData.SignFileID); //未签字
        }
      }
      this.xy.unloading();
    },
    async getSign(id) {
      //获取未签字文件详情
      this.xy.loading();
      let res = await this.xyapi.get(
        `${this.$store.state.apiPath}/api/SignFileManage/GetPreviewFileData`,
        {
          SignFileId: id,
          FileName: ""
        }
      );
      if (res.success) {
        this.previewList = res.data;
        this.setFormat();
      }
      this.xy.unloading();
    },
    async viewSign(id) {
      //已签字文件详情
      this.xy.loading();
      let res = await this.xyapi.get(
        `${this.$store.state.apiPath}/api/SignFileDetailManage/GetSignedFileData`,
        {
          SignFileDetailID: id
        }
      );
      if (res.success) {
        this.previewList = res.data;
        this.setFormat();
      }
      this.xy.unloading();
    },
    setFormat() {
      let arr = [];
      this.tag = "";
      this.previewList.forEach(item => {
        if (item.IsTable) {
          let style = "",
            tableObj = item.Tables;
          for (let key in tableObj.LayoutStyle) {
            if (tableObj.LayoutStyle[key]) {
              let attrs =
                key.charAt(0).toLowerCase() + key.slice(1, key.length);
              attrs = attrs.replace(/([A-Z])/g, "-$1").toLowerCase(); //将大驼峰改为css属性名格式
              style += attrs + ":" + tableObj.LayoutStyle[key] + ";";
            }
          }
          let tableRows = item.Tables.TRows,
            rows = "",
            columns = "",
            columnStyle = "";
          if (tableRows.length > 0) {
            tableRows.forEach(row => {
              columns = "";
              row.forEach(column => {
                for (let key in column.LayoutStyle) {
                  if (column.LayoutStyle[key]) {
                    let attrs =
                      key.charAt(0).toLowerCase() + key.slice(1, key.length);
                    attrs = attrs.replace(/([A-Z])/g, "-$1").toLowerCase();
                    columnStyle += attrs + ":" + column.LayoutStyle[key] + ";";
                  }
                }
                //如果文本为null  字体显示为白色
                if (!column.Text || column.Text === null) {
                  if (column.FontStyle) {
                    column.FontStyle.color = "#fff";
                  } else {
                    column.FontStyle = { color: "#fff" };
                  }
                } else {
                  column.FontStyle.color = "black";
                }
                for (let keys in column.FontStyle) {
                  if (column.FontStyle[keys]) {
                    let attrs =
                      keys.charAt(0).toLowerCase() + keys.slice(1, keys.length);
                    attrs = attrs.replace(/([A-Z])/g, "-$1").toLowerCase();
                    columnStyle += attrs + ":" + column.FontStyle[keys] + ";";
                  }
                }
                columns += `<td style="${columnStyle}">${
                  column.Text === "签字确认：{$}"
                    ? "签字确认：<span style='color:red;'>您的签字将在此处展示</span>"
                    : column.Text
                }</td>`;
              });
              rows += `<tr>${columns}</tr>`;
            });
          }
          arr.push(
            `<div style="width:100%;overflow:auto;"><table  style="${style}">${rows}</table></div>`
          );
        } else if (item.IsImage) {
          // 图片格式类似于： <div  style=""><image/></div>
          let style = "";
          for (let keyImage in item.LayoutStyle) {
            if (item.LayoutStyle[keyImage]) {
              let attrs =
                keyImage.charAt(0).toLowerCase() +
                keyImage.slice(1, keyImage.length);
              attrs = attrs.replace(/([A-Z])/g, "-$1").toLowerCase(); //将大驼峰改为css属性名格式
              style += attrs + ":" + item.LayoutStyle[keyImage] + ";";
            }
          }
          for (let keyi in item.FontStyle) {
            if (item.FontStyle[keyi]) {
              let attrs =
                keyi.charAt(0).toLowerCase() + keyi.slice(1, keyi.length);
              attrs = attrs.replace(/([A-Z])/g, "-$1").toLowerCase();
              style += attrs + ":" + item.FontStyle[keyi] + ";";
            }
          }
          let img = "",
            imgStyle = "";
          //每张图片的格式
          if (item.Images.length > 0) {
            item.Images.forEach(function(every) {
              imgStyle = "";
              for (let key in every.ImgStyle) {
                if (every.ImgStyle[key]) {
                  let attrs =
                    key.charAt(0).toLowerCase() + key.slice(1, key.length);
                  imgStyle +=
                    attrs +
                    ":" +
                    (attrs === "width"
                      ? every.ImgStyle[key] > 300
                        ? "100%"
                        : every.ImgStyle[key] + "px"
                      : attrs === "height"
                      ? ""
                      : every.ImgStyle[key] + "px") +
                    ";";
                }
              }
              for (let key in every.LayoutStyle) {
                if (every.LayoutStyle[key]) {
                  let attrs =
                    key.charAt(0).toLowerCase() + key.slice(1, key.length);
                  attrs = attrs.replace(/([A-Z])/g, "-$1").toLowerCase();
                  imgStyle += attrs + ":" + every.LayoutStyle[key] + ";";
                }
              }
              img += `<image style="${imgStyle}" src="${every.Src}" />`;
            });
          }
          arr.push(`<div style="${style}">${img}</div>`);
        } else {
          let style = "";
          for (let key in item.LayoutStyle) {
            if (item.LayoutStyle[key]) {
              let attrs =
                key.charAt(0).toLowerCase() + key.slice(1, key.length);
              attrs = attrs.replace(/([A-Z])/g, "-$1").toLowerCase(); //将大驼峰改为css属性名格式
              style +=
                attrs +
                ":" +
                (item.IsTitle
                  ? attrs === "line-height"
                    ? "inherit"
                    : item.LayoutStyle[key]
                  : item.LayoutStyle[key]) +
                ";";
            }
          }
          if (!item.Text || item.Text === null) {
            if (item.FontStyle) {
              item.FontStyle.color = "#fff";
            } else {
              item.FontStyle = { color: "#fff" };
            }
          }
          for (let key in item.FontStyle) {
            if (item.FontStyle[key]) {
              let attrs =
                key.charAt(0).toLowerCase() + key.slice(1, key.length);
              attrs = attrs.replace(/([A-Z])/g, "-$1").toLowerCase();
              style += attrs + ":" + item.FontStyle[key] + ";";
            }
          }
          arr.push(`<p  style="${style}">
          ${
            item.Text
              ? item.Text.indexOf("：http") > -1
                ? `签字确认：<img style='width:100px;' src='${
                    item.Text.split("：")[1]
                  }' />`
                : item.Text === "签字确认：{$}"
                ? "签字确认：<span style='color:red;'>您的签字将在此处展示</span>"
                : item.Text
              : item.Text
          }
          </p>`);
        }
      });
      arr.forEach(item => {
        this.tag += item;
      });
    },
    goSigning() {
      this.$router.push("/homeSchool/Signing");
    }
  }
};
</script>
<style lang="less" scoped>
.signdetails {
  display: flex;
  flex-flow: column;
  height: 100%;
}
.tag-list {
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 20px 200px;
  background: #fff;
  flex: 1;
}
.s-btn {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9f9f9;
  position: fixed;
  bottom: 0;
  width: 100%;
  div {
    width: 200px;
    height: 70px;
    line-height: 70px;
    color: #fff;
    font-size: 28px;
    border-radius: 35px;
    background: #4196ff;
    text-align: center;
  }
}
</style>
